import { render, staticRenderFns } from "./BMenuItem.vue?vue&type=template&id=7ac56f3a&scoped=true&"
import script from "./BMenuItem.vue?vue&type=script&lang=js&"
export * from "./BMenuItem.vue?vue&type=script&lang=js&"
import style0 from "./BMenuItem.vue?vue&type=style&index=0&id=7ac56f3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ac56f3a",
  null
  
)

export default component.exports